export default __webpack_public_path__ + "static/media/QrCode.2304104a.jpeg";